let client = null;
let elements = null;
let payment = null;

export function init() {
    const config = window.Gifted.stripe;

    client = window.Stripe(config.public_key);

    let initialAmount = parseFloat(window.Gifted.subtotal);

    if (initialAmount === 0) {
        initialAmount = 1;
    }

    elements = client.elements({
        amount: Math.round(initialAmount * 100),
        appearance: {
            rules: config.rules,
            theme: 'flat',
            variables: config.style,
        },
        currency: config.currency.trim().toLowerCase(),
        mode: 'payment',
        onBehalfOf: config.account_id,
        paymentMethodConfiguration: config.payment_methods,
    });

    payment = elements.create('payment', {
        layout: 'tabs',
    });
}

export function mountElement(selector) {
    if (!payment) {
        init();
    }

    payment.mount(selector);
}

export function updateAmount(amount) {
    if (!elements || amount === 0) return;

    elements.update({
        amount: Math.round(amount * 100),
    });
}

export async function getToken(billingDetails) {
    const { error: submitError } = await elements.submit();

    if (submitError) {
        return { confirmationToken: null, error: submitError };
    }

    const { confirmationToken, error } = await client.createConfirmationToken({
        elements,
        params: {
            payment_method_data: {
                billing_details: billingDetails,
            },
        },
    });

    return { confirmationToken, error };
}

export async function handleNextAction(clientSecret) {
    const { error, paymentIntent } = await client.handleNextAction({
        clientSecret,
    });

    return { error, paymentIntent };
}
